export const FOCUS_STYLES = (FOUNDATIONS) => `
  /* Inner border */
  box-shadow:
    0 0 0 ${FOUNDATIONS.spread_50} ${FOUNDATIONS.color_effect_focus_50},
    0 0 0 ${FOUNDATIONS.spread_100} ${FOUNDATIONS.color_effect_focus_100};
  /* Outer border */
  outline-style: solid;
  outline-offset: ${'0.125rem'};
  outline-width: ${'0.125rem'};
  outline-color: ${FOUNDATIONS.color_effect_focus_50};
`;
//# sourceMappingURL=focusStyles.js.map